module.exports = __webpack_public_path__ + "img/auth_0.18080ce9.png";